let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_REQUEST": "Create Request",
    "LBL_VIEW_REQUEST": "View Request",
    "LBL_PI_NAME": "PI Name",
    "LBL_PI_MOBILE": "PI Mobile",
    "LBL_PI_PROFESSIONAL": "PI Professional",
    "LBL_CREATED_BY": "Created By",
    "LBL_PARENT_ID": "Parent ID",
    "LBL_PARENT_TYPE": "Parent Type",
    "LBL_DESCRIPTION":"Description",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
    "LBL_REQUEST_TO":"Request To",
    "LBL_REQUEST_BY":"Request By",
    "LBL_ADD_REQUESTS":"Add Request",
    "LBL_REQUEST_DESC":"Request Description",
    "LBL_ED_SUPPORT_DOC":"Select File",
    "LBL_ED_SUPPORT_REQUEST":"ED Support Request",
    "LBL_REQUEST_STATUS":"Request Status",
    "LBL_EDIT_REQUESTS":"Edit Request",
    "LBL_DOCUMENT_REQUEST":"Request Document",
    "LBL_DOCUMENT_APPROVED":"Approved Document",
    "LBL_REQUEST_NO":"Request No",
    "LBL_RELATED_TICKET":"Related Support Request",
}

export default language;